import { Route, Routes } from 'react-router-dom';
import AracTakipDashboard from '../content/Dashboard/AracTakip';
import HavaleDashboard from '../content/Dashboard/Havale';
import CargoDashboard from '../content/Dashboard/Kargo';
import DashboardCustomer from '@/content/Dashboard/DashboardCustomer';
import BalanceDetails from '@/components/Dashboard/BalanceDetails';

const Dashboard = () => {
  return (
    <Routes>
      <Route path="/" children={<CargoDashboard />}>
        <Route path="customer" element={<DashboardCustomer />} />
        <Route path="balance-details" element={<BalanceDetails />} />
        <Route path="havale" element={<HavaleDashboard />} />
        <Route path="AracTakip" element={<AracTakipDashboard />} />
      </Route>
    </Routes>
  );
};

export default Dashboard;
